import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "student-analysis-container" }
const _hoisted_2 = { class: "filter-section" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = { class: "filter-item" }
const _hoisted_6 = { class: "filter-actions" }
const _hoisted_7 = {
  key: 0,
  class: "analysis-content"
}
const _hoisted_8 = { class: "student-info-card" }
const _hoisted_9 = { class: "student-avatar" }
const _hoisted_10 = { class: "student-details" }
const _hoisted_11 = { class: "summary-cards" }
const _hoisted_12 = { class: "summary-card total-score-card" }
const _hoisted_13 = { class: "card-value" }
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "summary-card rank-card" }
const _hoisted_16 = { class: "card-footer" }
const _hoisted_17 = { class: "summary-card pass-rate-card" }
const _hoisted_18 = { class: "card-value" }
const _hoisted_19 = { class: "card-footer" }
const _hoisted_20 = {
  class: "color-legend",
  style: {"margin-top":"16px","padding":"12px","background":"#f8f9fa","border-radius":"8px"}
}
const _hoisted_21 = { class: "table-container" }
const _hoisted_22 = { class: "score-summary-table" }
const _hoisted_23 = { class: "pass-line" }
const _hoisted_24 = { class: "compare-header" }
const _hoisted_25 = { class: "compare-exam-info" }
const _hoisted_26 = { class: "exam-name" }
const _hoisted_27 = { class: "compare-exam-info" }
const _hoisted_28 = { class: "exam-name" }
const _hoisted_29 = { class: "charts-section" }
const _hoisted_30 = { class: "chart-container" }
const _hoisted_31 = { class: "chart-container" }
const _hoisted_32 = { class: "chart-container" }
const _hoisted_33 = {
  key: 1,
  class: "select-prompt"
}

import { ref, onMounted, computed, watch } from 'vue';
import { useUserStore } from '@/store';
import { message } from 'ant-design-vue';
import { SearchOutlined, UserOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue';
import { getClassesApi, getClassesDetailApi } from '@/servers/api/classes';
import { getStudentApi } from '@/servers/api/student';
import { getClassExam } from '@/servers/api/grade';
import { getGradeApi } from '@/servers/api/grade';
import { getPassLine, getStudentSelfCompareApi } from '@/servers/api/analysis';
import { getExamDetailApi } from '@/servers/api/exam';
import { getTotalScore, getTotalClassRank, getTotalSchoolRank, groupPassLine } from '@/utils/subjects';
import type { ColumnType } from 'ant-design-vue/es/table';
import StudentAnalysisPages from '@/views/teacher/components/StudentAnalysisPages.vue';
// 类型定义
interface Student {
  student_id: string;
  student_name: string;
}

interface Exam {
  id: number;
  name: string;
}

interface ScoreDetail {
  subject: string;
  subjectName: string;
  score: number;
  classRank: number;
  gradeRank: number;
}

// 扩展科目类型定义
interface SubjectItem {
  code: string; // 科目名（中文，如 语文/数学）
  name: string; // 科目名称（中文）
}

// 完整科目列表（中文科目名）
interface ClassInfo {
  id: number;
  name: string;
  header: string | null;
  school_id: string | null;
  subject_selection: string;
}
const defaultSubjectSelection = '物化生史地'; // 可以修改为实际的默认选科

// 获取班级选科信息的备用函数

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentAnalysis',
  setup(__props) {

const allSubjectMap: Record<string, string> = {
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '政治': '政治',
  '地理': '地理',
  '总分': '总分'
};

// 状态管理
const userStore = useUserStore();
const classId = ref<number>(0);
const teacherId = ref<string>('');
const loading = ref(false);
const searchKeyword = ref('');

// 班级信息
const classInfo = ref<ClassInfo | null>(null);

// 备用选科配置（如果 API 返回的选科信息为空，使用此配置）
const getEffectiveSubjectSelection = (): string => {
  // 优先使用班级信息的选科
  console.log("!!!!!!!!!!!",classInfo.value);
  if (classInfo.value?.subject_selection && classInfo.value.subject_selection.trim() !== '') {
    return classInfo.value.subject_selection;
  }

  
  // 如果班级信息中没有选科，使用默认配置
  return defaultSubjectSelection;
};

// 数据列表
const studentList = ref<Student[]>([]);
const filteredStudentList = ref<Student[]>([]);
const examList = ref<Exam[]>([]);
const examMap = ref<Record<number, string>>({}); 
const scoreDetails = ref<any>({});
const passLineDetails = ref<any>({});
const compareData = ref<any>(null); // 存储对比数据

// 选择状态
const selectedStudentId = ref<string>('');
const selectedExamId = ref<number>(0);
const selectedComparedExamId = ref<number | undefined>(undefined);

// 学号脱敏处理：只显示后四位，前面用*表示
const maskStudentId = (id: string) => {
  if (!id) return '';
  if (id.length <= 4) return id; // 如果学号长度小于等于4位，不脱敏
  return '*'.repeat(id.length - 4) + id.slice(-4);
};

// 学生选项（用于下拉框）
const filteredStudentOptions = computed(() => {
  return filteredStudentList.value.map(student => ({
    label: `${student.student_name} (${maskStudentId(student.student_id)})`,
    value: student.student_id
  }));
});

// 考试选项
const examOptions = computed(() => {
  return examList.value.map(exam => ({
    label: examMap.value[exam.id] || exam.name,
    value: exam.id
  }));
});

// 对比考试选项（排除当前选中的考试）
const comparedExamOptions = computed(() => {
  return examList.value
    .filter(exam => exam.id !== selectedExamId.value)
    .map(exam => ({
      label: examMap.value[exam.id] || exam.name,
      value: exam.id
    }));
});

// 当前学生信息
const currentStudentInfo = computed(() => {
  const student = studentList.value.find(s => s.student_id === selectedStudentId.value);
  return student || { student_id: '', student_name: '' };
});

const getPreviousExamId = computed(() => {
  if (examList.value.length >= 2) {
    return examList.value[1].id;
  }
  return undefined;
});

// 当前考试信息
const currentExamInfo = computed(() => {
  const exam = examList.value.find(e => e.id === selectedExamId.value);
  return exam || { id: 0, name: '' };
});

const displaySubjects = computed<SubjectItem[]>(() => {
  if (!selectedStudentId.value || !selectedExamId.value) return [];

  const scoreDetail = scoreDetails.value[selectedExamId.value];
  if (!scoreDetail) return [];

  // 获取班级选科信息（使用备用函数）
  const subjectSelection = getEffectiveSubjectSelection();

  // 判断科目是否应该显示（根据班级选科）
  const shouldShowSubject = (code: string): boolean => {
    // 如果没有选科信息或为空字符串，显示所有科目
    if (!subjectSelection || subjectSelection.trim() === '') {
      return true;
    }

    // 根据科目code判断
    switch (code) {
      case '物理':
        return subjectSelection.includes('物');
      case '化学':
        return subjectSelection.includes('化');
      case '生物':
        return subjectSelection.includes('生');
      case '历史':
        return subjectSelection.includes('史');
      case '政治':
        return subjectSelection.includes('政');
      case '地理':
        return subjectSelection.includes('地');
      default:
        // 语数英等主科始终显示
        return true;
    }
  };

  // 筛选出有成绩、班级排名和年级排名的科目
  const validSubjects = Object.keys(allSubjectMap)
    .filter(code => {
      // 排除总分，只保留单科
      if (code === '总分') return false;

      // 根据选科过滤
      const shouldShow = shouldShowSubject(code);
      if (!shouldShow) return false;

      // 获取成绩和排名数据
      const score = scoreDetail.subjects?.[code]?.score;
      const classRank = scoreDetail.subjects?.[code]?.class_rank;
      const gradeRank = scoreDetail.subjects?.[code]?.school_rank;

      // 只保留成绩、班级排名和年级排名都存在的科目（0也是有效值）
      return score !== null && score !== undefined &&
             classRank !== null && classRank !== undefined &&
             gradeRank !== null && gradeRank !== undefined;
    })
    .map(code => ({
      code,
      name: allSubjectMap[code] || code
    }));

  return validSubjects;
});

// 总分相关计算
const totalScore = computed(() => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? getTotalScore(detail) : 0;
});

const totalClassRank = computed(() => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? getTotalClassRank(detail) : 0;
});

const totalGradeRank = computed(() => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? getTotalSchoolRank(detail) : 0;
});

// 及格率相关计算
const passSubjectCount = computed(() => {
  return filteredScoreData.value.filter(item => item.score >= 60).length;
});

const subjectCount = computed(() => {
  return filteredScoreData.value.length;
});

const passRate = computed(() => {
  if (subjectCount.value === 0) return 0;
  return ((passSubjectCount.value / subjectCount.value) * 100).toFixed(0);
});

// 获取单科成绩
const getSubjectScore = (subject: string) => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? detail.subjects?.[subject]?.score || 0 : 0;
};

// 获取单科特控线
const getSubjectPassLine = (subject: string) => {
  const detail = passLineDetails.value[selectedExamId.value];
  return detail ? detail[subject] || 0 : 0;
};

// 获取单科班级排名
const getSubjectClassRank = (subject: string) => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? detail.subjects?.[subject]?.class_rank || 0 : 0;
};

// 获取单科年级排名
const getSubjectGradeRank = (subject: string) => {
  const detail = scoreDetails.value[selectedExamId.value];
  return detail ? detail.subjects?.[subject]?.school_rank || 0 : 0;
};

const compareColumns: ColumnType[] = [
  {
    title: '科目',
    dataIndex: 'subjectName',
    key: 'subjectName',
    align: 'center',
    width: 100,
    fixed: 'left'
  },
  {
    title: '当前成绩',
    dataIndex: 'currentScore',
    key: 'currentScore',
    align: 'center',
    width: 90
  },
  {
    title: '对比成绩',
    dataIndex: 'compareScore',
    key: 'compareScore',
    align: 'center',
    width: 90
  },
  {
    title: '成绩差',
    dataIndex: 'scoreDiff',
    key: 'scoreDiff',
    align: 'center',
    width: 90
  },
  {
    title: '当前班排',
    dataIndex: 'currentClassRank',
    key: 'currentClassRank',
    align: 'center',
    width: 90
  },
  {
    title: '对比班排',
    dataIndex: 'compareClassRank',
    key: 'compareClassRank',
    align: 'center',
    width: 90
  },
  {
    title: '班排差',
    dataIndex: 'classRankDiff',
    key: 'classRankDiff',
    align: 'center',
    width: 80
  },
  {
    title: '当前年排',
    dataIndex: 'currentGradeRank',
    key: 'currentGradeRank',
    align: 'center',
    width: 90
  },
  {
    title: '对比年排',
    dataIndex: 'compareGradeRank',
    key: 'compareGradeRank',
    align: 'center',
    width: 90
  },
  {
    title: '年排差',
    dataIndex: 'gradeRankDiff',
    key: 'gradeRankDiff',
    align: 'center',
    width: 80
  }
];
  // 原始成绩数据
const rawScoreData = computed<ScoreDetail[]>(() => {
  if (!selectedStudentId.value || !selectedExamId.value) return [];

  const data: ScoreDetail[] = [];
  const scoreDetail = scoreDetails.value[selectedExamId.value];

  if (!scoreDetail) return [];

  // 获取班级选科信息（使用相同的逻辑）
  const subjectSelection = getEffectiveSubjectSelection();
  console.log('rawScoreData - 班级选科信息:', subjectSelection);

  // 判断科目是否应该显示（根据班级选科）
  const shouldShowSubject = (code: string): boolean => {
    // 如果没有选科信息或为空字符串，显示所有科目
    if (!subjectSelection || subjectSelection.trim() === '') {
      return true;
    }

    // 根据科目code判断
    switch (code) {
      case '物理':
        return subjectSelection.includes('物');
      case '化学':
        return subjectSelection.includes('化');
      case '生物':
        return subjectSelection.includes('生');
      case '历史':
        return subjectSelection.includes('史');
      case '政治':
        return subjectSelection.includes('政');
      case '地理':
        return subjectSelection.includes('地');
      default:
        // 语数英等主科始终显示
        return true;
    }
  };

  // 遍历所有可能的科目
  Object.keys(allSubjectMap).forEach(subject => {
    if (subject === '总分') return;

    // 根据选科过滤
    if (!shouldShowSubject(subject)) return;

    const score = scoreDetail.subjects?.[subject]?.score;
    const classRank = scoreDetail.subjects?.[subject]?.class_rank;
    const gradeRank = scoreDetail.subjects?.[subject]?.school_rank;

    // 只添加成绩、班级排名和年级排名都存在的科目（0也是有效值）
    if (score !== null && score !== undefined &&
        classRank !== null && classRank !== undefined &&
        gradeRank !== null && gradeRank !== undefined) {
      data.push({
        subject,
        subjectName: allSubjectMap[subject],
        score: score || 0,
        classRank: classRank || 0,
        gradeRank: gradeRank || 0
      });
    }
  });

  console.log('rawScoreData - 过滤后的科目:', data.map(s => s.name));
  return data;
});

// 获取差值类名（线差专用）
const getDifferenceClass = (difference: number) => {
  if (difference > 0) {
    return 'positive-difference'; // 正数绿色
  } else if (difference < 0) {
    return 'negative-difference'; // 负数红色
  }
  return ''; 
};

const filteredScoreData = computed<ScoreDetail[]>(() => {
  return rawScoreData.value;
});

// 对比表格数据
const compareTableData = computed(() => {
  if (!compareData.value) return [];
  
  const data: any[] = [];
  const compareDataValue = compareData.value;
  
  // 获取班级选科信息
  const subjectSelection = getEffectiveSubjectSelection();
  console.log('compareTableData - 班级选科信息:', subjectSelection);

  // 判断科目是否应该显示（根据班级选科）
  const shouldShowSubject = (code: string): boolean => {
    if (!subjectSelection || subjectSelection.trim() === '') {
      return true;
    }
    switch (code) {
      case '物理':
        return subjectSelection.includes('物');
      case '化学':
        return subjectSelection.includes('化');
      case '生物':
        return subjectSelection.includes('生');
      case '历史':
        return subjectSelection.includes('史');
      case '政治':
        return subjectSelection.includes('政');
      case '地理':
        return subjectSelection.includes('地');
      default:
        return true;
    }
  };

  // 添加总分（扁平中文键）
  if (compareDataValue['总分']) {
    data.push({
      subject: '总分',
      subjectName: '总分',
      currentScore: compareDataValue['总分'].current || 0,
      compareScore: compareDataValue['总分'].compare || 0,
      scoreDiff: Number(compareDataValue['总分'].difference || 0),
      currentClassRank: compareDataValue['总分班次']?.current || 0,
      compareClassRank: compareDataValue['总分班次']?.compare || 0,
      classRankDiff: compareDataValue['总分班次']?.difference || 0,
      currentGradeRank: compareDataValue['总分段次']?.current || 0,
      compareGradeRank: compareDataValue['总分段次']?.compare || 0,
      gradeRankDiff: compareDataValue['总分段次']?.difference || 0
    });
  }

  // 添加有完整数据的科目成绩（根据班级选科过滤）
  Object.keys(allSubjectMap).forEach(subject => {
    if (subject === '总分') return;

    // 根据选科过滤
    if (!shouldShowSubject(subject)) {
      console.log(`compareTableData - 跳过科目: ${subject} (${allSubjectMap[subject]})`);
      return;
    }

    const subjectData = compareDataValue[subject];
    if (!subjectData) return;

    const classRankKey = `${subject}班次`;
    const gradeRankKey = `${subject}段次`;

    if (compareDataValue[classRankKey] && compareDataValue[gradeRankKey]) {
      data.push({
        subject,
        subjectName: allSubjectMap[subject],
        currentScore: subjectData.current || 0,
        compareScore: subjectData.compare || 0,
        scoreDiff: Number(subjectData.difference || 0),
        currentClassRank: compareDataValue[classRankKey]?.current || 0,
        compareClassRank: compareDataValue[classRankKey]?.compare || 0,
        classRankDiff: compareDataValue[classRankKey]?.difference || 0,
        currentGradeRank: compareDataValue[gradeRankKey]?.current || 0,
        compareGradeRank: compareDataValue[gradeRankKey]?.compare || 0,
        gradeRankDiff: compareDataValue[gradeRankKey]?.difference || 0
      });
    }
  });

  console.log('compareTableData - 过滤后的科目:', data.map(s => s.subjectName));
  return data;
});

// 成绩图表选项（只展示有完整数据的科目）
const scoreChartOption = computed(() => {
  const subjects = filteredScoreData.value.map(item => item.subjectName);
  const scores = filteredScoreData.value.map(item => item.score);
  // 获取特控线数据
  const passLineData = filteredScoreData.value.map(item => {
    const passLine = passLineDetails.value[selectedExamId.value];
    if (!passLine) return 0;
    // 根据科目编码查找对应的特控线
    const code = item.subject;
    return passLine[code] || 0;
  });

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      }
    },
    legend: {
      data: ['本人成绩', '特控线'],
      top: '5%'
    },
    xAxis: {
      type: 'category',
      data: subjects
    },
    yAxis: {
      type: 'value',
      name: '分数'
    },
    series: [
      {
        name: '本人成绩',
        type: 'line',
        data: scores,
        itemStyle: {
          color: '#1890ff'
        },
        lineStyle: {
          color: '#1890ff',
          width: 3,
          type: 'solid'
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#333'
        },
        symbolSize: 8
      },
      {
        name: '特控线',
        type: 'line',
        data: passLineData,
        itemStyle: {
          color: '#f5222d'
        },
        lineStyle: {
          color: '#f5222d',
          width: 2,
          type: 'dashed'
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#f5222d'
        },
        symbolSize: 6
      }
    ]
  };
});

// 班级排名图表选项（只展示有完整数据的科目）
const classRankChartOption = computed(() => {
  const subjects = filteredScoreData.value.map(item => item.subjectName);
  const classRanks = filteredScoreData.value.map(item => item.classRank);

  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['班级排名']
    },
    xAxis: {
      type: 'category',
      data: subjects
    },
    yAxis: {
      type: 'value',
      name: '排名',
      inverse: true
    },
    series: [
      {
        name: '班级排名',
        type: 'line',
        data: classRanks,
        itemStyle: {
          color: '#1890ff'
        },
        lineStyle: {
          color: '#1890ff',
          width: 3,
          type: 'solid'
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#333'
        },
        symbolSize: 8
      }
    ]
  };
});

// 年级排名图表选项（只展示有完整数据的科目）
const gradeRankChartOption = computed(() => {
  const subjects = filteredScoreData.value.map(item => item.subjectName);
  const gradeRanks = filteredScoreData.value.map(item => item.gradeRank);

  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['年级排名']
    },
    xAxis: {
      type: 'category',
      data: subjects
    },
    yAxis: {
      type: 'value',
      name: '排名',
      inverse: true
    },
    series: [
      {
        name: '年级排名',
        type: 'line',
        data: gradeRanks,
        itemStyle: {
          color: '#fa8c16'
        },
        lineStyle: {
          color: '#fa8c16',
          width: 3,
          type: 'solid'
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#333'
        },
        symbolSize: 8
      }
    ]
  };
});

// 处理学生搜索
const handleStudentSearch = (value: string) => {
  searchKeyword.value = value;
  if (!value) {
    filteredStudentList.value = [...studentList.value];
    return;
  }
  
  const filtered = studentList.value.filter(student => 
    student.student_name.toLowerCase().includes(value.toLowerCase()) ||
    student.student_id.toLowerCase().includes(value.toLowerCase())
  );
  filteredStudentList.value = filtered;
};

// 获取成绩等级类名
const getScoreClass = (score: number, subject: string) => {
  if (subject === '总分') {
    return score >= 600 ? 'excellent-score' : score >= 500 ? 'good-score' : 'normal-score';
  }
  return score >= 90 ? 'excellent-score' : score >= 80 ? 'good-score' : 'normal-score';
};

// 获取排名类名
const getRankClass = (rank: number) => {
  return rank <= 3 ? 'top-rank' : rank <= 10 ? 'good-rank' : 'normal-rank';
};


// 获取排名差值类名（排名越小越好，所以正数表示下降，负数表示上升）
const getRankDifferenceClass = (difference: number) => {
  return difference > 0 ? 'rank-down' : difference < 0 ? 'rank-up' : 'rank-same';
};

// 格式化分数，保留一位小数
const formatScore = (score: number) => {
  return Number.isInteger(score) ? score : score.toFixed(1);
};

// 自动设置对比考试为上一次考试
const autoSetComparedExam = async () => {
  if (!selectedStudentId.value || !selectedExamId.value) return;
  
  const previousExamId = getPreviousExamId.value;
  if (previousExamId && previousExamId !== selectedComparedExamId.value) {
    selectedComparedExamId.value = previousExamId;
    await fetchCompareData(selectedStudentId.value, selectedExamId.value, previousExamId);
  }
};

// 监听考试选择变化，自动设置对比考试
watch([selectedExamId, selectedStudentId], async () => {
  if (selectedStudentId.value && selectedExamId.value) {
    await autoSetComparedExam();
  }
}, { immediate: true });

// 初始化
onMounted(async () => {
  try {
    loading.value = true;
    const userInfo = userStore.getUserInfo();
    const header = String(userInfo?.role || userInfo?.teacher?.uid || '').trim();
    
    if (!header) {
      message.error('未获取到教师信息');
      return;
    }

    let classes: ClassInfo[] = [];
    const classRes = await getClassesApi({ header });
    if (classRes.code === 200 && classRes.data.length > 0) {
      classes = classRes.data;
    }

    // 兼容非班主任教师：回退全班级（可按学校过滤）
    if (classes.length === 0) {
      const allClassRes = await getClassesApi({});
      if (allClassRes.code === 200 && Array.isArray(allClassRes.data)) {
        classes = allClassRes.data;
      }
      if (classes.length > 0) {
        console.warn('未找到班主任绑定班级，已切换为全班级');
      }
    }

    if (classes.length === 0) {
      message.error('未查询到教师关联的班级信息');
      return;
    }

    teacherId.value = String(classes[0].header || '');
    classId.value = classes[0].id;
    
    // 获取班级详细信息(包含选科信息)
    await fetchClassInfo(classId.value);
    
    await fetchExamList()
    await fetchStudentList();
    await handleExamChange(selectedExamId.value);
  } catch (err) {
    message.error('初始化失败');
    console.error(err);
  } finally {
    loading.value = false;
  }
});

// 获取学生列表
const fetchStudentList = async () => {
  try {
    loading.value = true;
    const res = await getStudentApi({ class_id: classId.value,page:1,size:9999 });
    
    if (res.code === 200) {
      studentList.value = res.data.map((student: any) => ({
        student_id: student.uid,
        student_name: student.name
      }));
      
      filteredStudentList.value = [...studentList.value];
      
      // 默认选择第一个学生
      if (studentList.value.length > 0 && !selectedStudentId.value) {
        selectedStudentId.value = studentList.value[0].student_id;
        // 获取第一个学生的考试成绩
        if (selectedExamId.value) {
          await fetchStudentGrades(selectedStudentId.value, selectedExamId.value);
        }
      }
    } else {
      message.error('获取学生列表失败');
    }
  } catch (err) {
    message.error('请求学生列表接口出错');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 获取考试列表
const fetchExamList = async () => {
  try {
    loading.value = true;
    // @ts-ignore
    const res = await getClassExam({ class_id: classId.value });
    if (res.code === 200) {
      // 直接使用返回的考试信息数组
      const examData = res.data;
      
      // 构建考试列表和映射
      examList.value = examData.map((exam: any) => {
        examMap.value[exam.id] = exam.name;
        return {
          id: exam.id,
          name: exam.name
        };
      });
      
      if (examList.value.length > 0) {
        // 默认选中最后一个考试
        selectedExamId.value = examList.value[0].id;
        
        // 如果已经有选中的学生，获取该学生的考试成绩
        if (selectedStudentId.value) {
          await fetchStudentGrades(selectedStudentId.value, selectedExamId.value);
          await fetchPassLine(selectedExamId.value);
        }
      }
    } else {
      message.error('获取考试列表失败');
    }
  } catch (err) {
    message.error('请求考试列表接口出错');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 获取学生成绩详情
const fetchStudentGrades = async (studentId: string, examId: number) => {
  try {
    loading.value = true;
    const res = await getGradeApi({ student_id: parseInt(studentId), exam_id: examId });
    
    if (res.code === 200 && res.data.length > 0) {
      scoreDetails.value[examId] = res.data[0];
    } else {
      message.warning('未获取到该考试的成绩数据');
      scoreDetails.value[examId] = {};
    }
  } catch (err) {
    message.error('请求成绩详情接口出错');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 获取分数线
const fetchPassLine = async (examId: number) => {
  try {
    const res = await getPassLine({ exam_id: examId, size: 200 });
    if (res.code === 200 && res.data.length > 0) {
      const rows: any[] = res.data;
      const subjectSel = classInfo.value?.subject_selection || '';

      // 行式按 line_group_id 分组
      const grouped = new Map<number, any[]>();
      rows.forEach((row: any) => {
        const gid = row.line_group_id;
        if (gid == null) return;
        if (!grouped.has(gid)) grouped.set(gid, []);
        grouped.get(gid)!.push(row);
      });
      const groups = Array.from(grouped.values());

      // 找到匹配选科的特控线组，组装成 {科目: 分数}
      let targetGroup: any[] | null = null;
      const matchGroup = (pred: (n: string) => boolean): any[] | null =>
        groups.find((g: any[]) => pred(g[0]?.line_name || '')) || null;

      if (subjectSel.includes('物')) {
        targetGroup = matchGroup((n) => (n.includes('物') || n.includes('理')) && n.includes('特控'));
      } else if (subjectSel.includes('史')) {
        targetGroup = matchGroup((n) => n.includes('史') && n.includes('特控'));
      } else {
        targetGroup = matchGroup((n) => n.includes('特控')) || groups[0] || null;
      }

      if (targetGroup && targetGroup.length > 0) {
        passLineDetails.value[examId] = groupPassLine(targetGroup);
      } else {
        message.warning('未找到匹配的特控线数据');
        passLineDetails.value[examId] = {};
      }
    } else {
      message.warning('未获取到该考试的分数线数据');
      passLineDetails.value[examId] = {};
    }
  } catch (err) {
    message.error('请求分数线接口出错');
    console.error(err);
  }
};

// 处理学生选择
const handleStudentChange = async (studentId: string) => {
  selectedStudentId.value = studentId;
  // 清空之前的数据
  scoreDetails.value = {};
  passLineDetails.value = {};
  compareData.value = null;
  selectedComparedExamId.value = undefined; // 重置对比考试选择

  // 获取该学生的考试成绩和分数线
  if (selectedExamId.value) {
    await Promise.all([
      fetchStudentGrades(studentId, selectedExamId.value),
      fetchPassLine(selectedExamId.value)
    ]);

    // 自动设置对比考试
    await autoSetComparedExam();
  }
};

// 处理考试选择
const handleExamChange = async (examId: number) => {
  selectedExamId.value = examId;
  // 清空对比数据
  compareData.value = null;
  selectedComparedExamId.value = undefined;
  
  // 获取成绩详情和分数线
  if (selectedStudentId.value) {
    await Promise.all([
      fetchStudentGrades(selectedStudentId.value, examId),
      fetchPassLine(examId)
    ]);
    
    // 自动设置对比考试
    await autoSetComparedExam();
  }
};

// 重置筛选
const resetFilters = () => {
  selectedStudentId.value = '';
  selectedExamId.value = examList.value.length > 0 ? examList.value[0].id : 0;
  selectedComparedExamId.value = undefined;
  scoreDetails.value = {};
  passLineDetails.value = {};
  compareData.value = null;
  searchKeyword.value = '';
  filteredStudentList.value = [...studentList.value];
};

// 获取考试对比数据
const fetchCompareData = async (studentId: string, examId: number, comparedExamId: number) => {
  try {
    loading.value = true;
    const res = await getStudentSelfCompareApi({
      student_id: parseInt(studentId),
      exam_id: examId,
      compared_exam_id: comparedExamId
    });
    
    if (res.code === 200 && res.data) {
      compareData.value = res.data;
    } else {
      message.warning('未获取到对比数据');
      compareData.value = null;
    }
  } catch (err) {
    message.error('请求对比数据接口出错');
    console.error(err);
    compareData.value = null;
  } finally {
    loading.value = false;
  }
};

// 处理对比考试选择
const handleComparedExamChange = async (comparedExamId: number | undefined) => {
  if (!comparedExamId) {
    compareData.value = null;
    return;
  }
  
  if (selectedStudentId.value && selectedExamId.value) {
    await fetchCompareData(selectedStudentId.value, selectedExamId.value, comparedExamId);
  }
};

const clearCompare = () => {
  selectedComparedExamId.value = undefined;
  compareData.value = null;
};

// 获取班级信息
const fetchClassInfo = async (classId: number) => {
  try {
    const res = await getClassesDetailApi({ class_id: classId });
    if (res.code === 200 && res.data) {
      classInfo.value = res.data[0];
      console.log('???班级信息:', res.data[0]);
      console.log('!!!!!!!!!选科信息:', res.data[0]?.subject_selection);
    } else {
      message.warning('未获取到班级信息');
    }
  } catch (err) {
    message.error('请求班级信息接口出错');
    console.error(err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_e_charts = _resolveComponent("e-charts")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "学生成绩分析"),
      _createElementVNode("p", null, "选择学生和考试查看详细成绩分析")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-label" }, "选择学生：", -1)),
                _createVNode(_component_a_select, {
                  value: selectedStudentId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedStudentId).value = $event)),
                  placeholder: "请输入学生姓名或学号搜索",
                  style: {"width":"100%"},
                  onChange: handleStudentChange,
                  options: filteredStudentOptions.value,
                  "show-search": "",
                  "filter-option": false,
                  onSearch: handleStudentSearch
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_unref(SearchOutlined))
                  ]),
                  _: 1
                }, 8, ["value", "options"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-label" }, "基准考试：", -1)),
                _createVNode(_component_a_select, {
                  value: selectedExamId.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedExamId).value = $event)),
                  placeholder: "请选择考试",
                  style: {"width":"100%"},
                  onChange: handleExamChange,
                  options: examOptions.value,
                  disabled: !selectedStudentId.value
                }, null, 8, ["value", "options", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "filter-label" }, "对比考试：", -1)),
                _createVNode(_component_a_select, {
                  value: selectedComparedExamId.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedComparedExamId).value = $event)),
                  placeholder: "请选择对比考试",
                  style: {"width":"100%"},
                  onChange: handleComparedExamChange,
                  options: comparedExamOptions.value,
                  disabled: !selectedStudentId.value || !selectedExamId.value,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    (selectedComparedExamId.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          onClick: clearCompare
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" 取消对比 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: resetFilters
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("重置筛选", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (selectedStudentId.value && selectedExamId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_a_row, {
            gutter: 16,
            class: "overview-section"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 24,
                md: 8
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(UserOutlined))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h3", null, _toDisplayString(currentStudentInfo.value.student_name), 1),
                      _createElementVNode("p", null, "学号: " + _toDisplayString(maskStudentId(currentStudentInfo.value.student_id)), 1),
                      _createElementVNode("p", null, "考试: " + _toDisplayString(examMap.value[selectedExamId.value] || currentExamInfo.value.name), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 24,
                md: 16
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_row, { gutter: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 12,
                          lg: 8
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-title" }, "总分", -1)),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(totalScore.value), 1),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", null, "班级排名: " + _toDisplayString(totalClassRank.value), 1),
                                _createElementVNode("span", null, "年级排名: " + _toDisplayString(totalGradeRank.value), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          span: 12,
                          lg: 8
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-title" }, "班级排名", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["card-value", getRankClass(totalClassRank.value)])
                              }, _toDisplayString(totalClassRank.value), 3),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", null, "年级排名: " + _toDisplayString(totalGradeRank.value), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          span: 12,
                          lg: 8
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-title" }, "及格率", -1)),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(passRate.value) + "%", 1),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", null, "及格科目: " + _toDisplayString(passSubjectCount.value) + "/" + _toDisplayString(subjectCount.value), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_20, [
            _cache[13] || (_cache[13] = _createElementVNode("div", {
              class: "legend-title",
              style: {"font-weight":"600","margin-bottom":"8px","color":"#333"}
            }, "成绩颜色说明：", -1)),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 8,
                  sm: 6,
                  md: 4
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "legend-item" }, [
                      _createElementVNode("span", {
                        class: "color-block",
                        style: {"background-color":"#52c41a"}
                      }),
                      _createElementVNode("span", { class: "color-text" }, "正向差值 ⬆"),
                      _createElementVNode("span", { class: "color-desc" }, "分数高/排名升")
                    ], -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 8,
                  sm: 6,
                  md: 4
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", { class: "legend-item" }, [
                      _createElementVNode("span", {
                        class: "color-block",
                        style: {"background-color":"#f5222d"}
                      }),
                      _createElementVNode("span", { class: "color-text" }, "负向差值 ⬇"),
                      _createElementVNode("span", { class: "color-desc" }, "分数低/排名降")
                    ], -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_row, {
            gutter: 16,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    title: "成绩汇总分析",
                    class: "summary-table-card"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("table", _hoisted_22, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[14] || (_cache[14] = _createElementVNode("th", null, null, -1)),
                              _cache[15] || (_cache[15] = _createElementVNode("th", null, "总分", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: subject.code
                                }, _toDisplayString(subject.name), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _cache[16] || (_cache[16] = _createElementVNode("td", { class: "row-label" }, "成绩", -1)),
                              _createElementVNode("td", {
                                class: _normalizeClass(getScoreClass(totalScore.value, '总分'))
                              }, _toDisplayString(totalScore.value), 3),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `score-${subject.code}`,
                                  class: _normalizeClass(getScoreClass(getSubjectScore(subject.code), subject.code))
                                }, _toDisplayString(getSubjectScore(subject.code)), 3))
                              }), 128))
                            ]),
                            _createElementVNode("tr", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "row-label" }, "特控线", -1)),
                              _createElementVNode("td", _hoisted_23, _toDisplayString(getSubjectPassLine('总分')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `pass-${subject.code}`,
                                  class: "pass-line"
                                }, _toDisplayString(getSubjectPassLine(subject.code)), 1))
                              }), 128))
                            ]),
                            _createElementVNode("tr", null, [
                              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "row-label" }, "线差", -1)),
                              _createElementVNode("td", {
                                class: _normalizeClass(getDifferenceClass(totalScore.value - getSubjectPassLine('总分')))
                              }, [
                                _createTextVNode(_toDisplayString(Math.abs(totalScore.value - getSubjectPassLine('总分')).toFixed(1)) + " ", 1),
                                (totalScore.value - getSubjectPassLine('总分') > 0)
                                  ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                  : (totalScore.value - getSubjectPassLine('总分') < 0)
                                    ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                    : _createCommentVNode("", true)
                              ], 2),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `diff-${subject.code}`,
                                  class: _normalizeClass(getDifferenceClass(getSubjectScore(subject.code) - getSubjectPassLine(subject.code)))
                                }, [
                                  _createTextVNode(_toDisplayString(Math.abs(getSubjectScore(subject.code) - getSubjectPassLine(subject.code)).toFixed(1)) + " ", 1),
                                  (getSubjectScore(subject.code) - getSubjectPassLine(subject.code) > 0)
                                    ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                    : (getSubjectScore(subject.code) - getSubjectPassLine(subject.code) < 0)
                                      ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                      : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("tr", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "row-label" }, "班次", -1)),
                              _createElementVNode("td", {
                                class: _normalizeClass(getRankClass(totalClassRank.value))
                              }, _toDisplayString(totalClassRank.value), 3),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `classRank-${subject.code}`,
                                  class: _normalizeClass(getRankClass(getSubjectClassRank(subject.code)))
                                }, _toDisplayString(getSubjectClassRank(subject.code)), 3))
                              }), 128))
                            ]),
                            _createElementVNode("tr", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "row-label" }, "段次", -1)),
                              _createElementVNode("td", {
                                class: _normalizeClass(getRankClass(totalGradeRank.value))
                              }, _toDisplayString(totalGradeRank.value), 3),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubjects.value, (subject) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `gradeRank-${subject.code}`,
                                  class: _normalizeClass(getRankClass(getSubjectGradeRank(subject.code)))
                                }, _toDisplayString(getSubjectGradeRank(subject.code)), 3))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (compareData.value && selectedComparedExamId.value)
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 0,
                gutter: 16,
                style: {"margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        title: "考试对比分析",
                        class: "compare-card"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "exam-label" }, "当前考试：", -1)),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(compareData.value.exam_name?.current || examMap.value[selectedExamId.value]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "exam-label" }, "对比考试：", -1)),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(compareData.value.exam_name?.compare || examMap.value[selectedComparedExamId.value]), 1)
                            ])
                          ]),
                          _createVNode(_component_a_table, {
                            columns: compareColumns,
                            "data-source": compareTableData.value,
                            pagination: false,
                            bordered: "",
                            size: "middle",
                            scroll: { y: 300 }
                          }, {
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.dataIndex === 'currentScore')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(getScoreClass(record.currentScore, record.subject))
                                  }, _toDisplayString(record.currentScore), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'compareScore')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(getScoreClass(record.compareScore, record.subject))
                                  }, _toDisplayString(record.compareScore), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'scoreDiff')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: _normalizeClass(getDifferenceClass(record.scoreDiff))
                                  }, [
                                    _createTextVNode(_toDisplayString(formatScore(Math.abs(record.scoreDiff))) + " ", 1),
                                    (record.scoreDiff > 0)
                                      ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                      : (record.scoreDiff < 0)
                                        ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                        : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'currentClassRank')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 3,
                                    class: _normalizeClass(getRankClass(record.currentClassRank))
                                  }, _toDisplayString(record.currentClassRank), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'compareClassRank')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 4,
                                    class: _normalizeClass(getRankClass(record.compareClassRank))
                                  }, _toDisplayString(record.compareClassRank), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'classRankDiff')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 5,
                                    class: _normalizeClass(getRankDifferenceClass(record.classRankDiff))
                                  }, [
                                    _createTextVNode(_toDisplayString(Math.abs(record.classRankDiff)) + " ", 1),
                                    (record.classRankDiff < 0)
                                      ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                      : (record.classRankDiff > 0)
                                        ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                        : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'currentGradeRank')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 6,
                                    class: _normalizeClass(getRankClass(record.currentGradeRank))
                                  }, _toDisplayString(record.currentGradeRank), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'compareGradeRank')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 7,
                                    class: _normalizeClass(getRankClass(record.compareGradeRank))
                                  }, _toDisplayString(record.compareGradeRank), 3))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'gradeRankDiff')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 8,
                                    class: _normalizeClass(getRankDifferenceClass(record.gradeRankDiff))
                                  }, [
                                    _createTextVNode(_toDisplayString(Math.abs(record.gradeRankDiff)) + " ", 1),
                                    (record.gradeRankDiff < 0)
                                      ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                      : (record.gradeRankDiff > 0)
                                        ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                        : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_a_row, {
              gutter: 16,
              style: {"margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      title: "成绩分布图",
                      class: "chart-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_e_charts, {
                            option: scoreChartOption.value,
                            style: {"height":"300px"}
                          }, null, 8, ["option"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      title: "班级排名分布",
                      class: "chart-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_e_charts, {
                            option: classRankChartOption.value,
                            style: {"height":"300px"}
                          }, null, 8, ["option"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      title: "年级排名分布",
                      class: "chart-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_e_charts, {
                            option: gradeRankChartOption.value,
                            style: {"height":"300px"}
                          }, null, 8, ["option"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_component_a_empty, { description: "请选择学生和考试查看成绩分析" })
        ])),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 2,
          tip: "加载中...",
          class: "loading-spin"
        }))
      : _createCommentVNode("", true),
    _createVNode(StudentAnalysisPages, {
      studentId: selectedStudentId.value,
      classInfo: classInfo.value,
      studentName: currentStudentInfo.value.student_name
    }, null, 8, ["studentId", "classInfo", "studentName"])
  ]))
}
}

})